export default __webpack_public_path__ + "static/media/DSC_0531.b7dcf23a.webp";